module.exports = __webpack_public_path__ + "img/api_response.d0aefcec.png";